import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	wrap: {
		minWidth: 0,
	},
	title: {
		margin: 0,
		color: theme.palette.text.primary,
		fontSize: "1.5rem",
		fontWeight: 700,
		lineHeight: 1.2,
		letterSpacing: 0,
		[theme.breakpoints.down("sm")]: {
			fontSize: "1.125rem",
		},
	},
	subtitle: {
		marginTop: 4,
		color: theme.palette.text.secondary,
		fontSize: "0.9rem",
		fontWeight: 400,
		lineHeight: 1.4,
		[theme.breakpoints.down("sm")]: {
			fontSize: "0.8rem",
			display: "none",
		},
	},
}));

export default function Title(props) {
	const classes = useStyles();

	return (
		<div className={classes.wrap}>
			<Typography variant="h5" className={classes.title}>
				{props.children}
			</Typography>
			{props.subtitle ? (
				<Typography className={classes.subtitle}>{props.subtitle}</Typography>
			) : null}
		</div>
	);
}
